<template>
    <div>
        <div>
            <div class="tag-title">总层级</div>
            <div @click="e=>clickCheckBox(item)"
                 :class="['checkbox-wrap',item.isActive===true?'checkbox-wrap-active':'']" :key="key"
                 v-for="(item,key) in checkBoxLists">{{item.name}}
            </div>
        </div>

    </div>

</template>

<script>
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'TagTitleList',
    props:{
      isOpt:{
        type:Boolean,
        default:true
      },
      tagTitleList:{
        type:Array,
        default:function () {
          return []
        }
      }
    },
    data() {
      return {
        checkBoxLists: this.tagTitleList
      }
    },
    components: {},
    mounted() {
    },
    watch:{
      tagTitleList(arra){
        this.checkBoxLists=arra
      }
    },
    methods: {
      clickCheckBox(info){
        this.checkBoxLists = this.checkBoxLists.map((item, key) => item.name == info.name ? Object.assign(item, {isActive: true}) : Object.assign(item, {isActive: false}))
        this.$emit('clickTagTitleItem',info)
      },

    }
  }
</script>
<style lang="stylus" scoped>

    .tag-item {
        display: inline-block;
        padding: 5px 6px;
        position: relative;
        border: 1px solid #409eff;
        margin: 2px 4px;
        font-size: 14px;
        border-radius: 3px;
    }

    .tag-item-add {
        display: inline-block;
        padding: 1px 6px;
        position: relative;
        font-size: 14px;
        cursor: pointer;
        margin: 0px;
    }

    .cancel-icon {
        background: white;
        position: absolute;
        top: -5px;
        right: -6px;
        font-size: 14px;
        color: #409eff;
        cursor: pointer
    }

    .checkbox-wrap {
        display: inline-block;
        padding: 2px 8px;
        border: 1px solid #dcdfe6;
        margin-left: -1px;
        cursor: pointer
    }
    .tag-title{
        font-weight: 700;
        font-size: 14px;
        display: inline-block;
        padding: 2px 8px 2px 0px;
    }

    .checkbox-wrap-active {
        background: #409eff;
        color: white;
        border-bottom: 1px solid #409eff;
    }
    .cancel-btn{
        display: inline-block;
        font-size: 14px;
        margin: 2px 4px;
        padding:5px 6px;
        background:  #409eff;
        color: white;
        border-radius: 5px;
        cursor:pointer
    }
</style>




// WEBPACK FOOTER //
// src/main/admin/component/TagTitleList.vue